import qs from "qs";
import http from "../http";

function getTodoTaskItemId(payload) {
  return http(
    "GET",
    `${window.API_URL}/workspace/work/next?${qs.stringify(payload)}`
  );
}

function getNextTaskItemId(payload) {
  return http(
    "GET",
    `${window.API_URL}/workspace/item/next?${qs.stringify(payload)}`
  );
}

function assignTaskItem(payload) {
  return http(
    "POST",
    `${window.API_URL}/workspace/work/next/allocate`,
    payload
  );
}

function getPrevTaskItemId(payload) {
  return http(
    "GET",
    `${window.API_URL}/workspace/item/prev?${qs.stringify(payload)}`
  );
}

function getWorkspaceInfo(payload) {
  return http("GET", `${window.API_URL}/workspace?${qs.stringify(payload)}`);
}

function getWorkspaceProgressInfo(payload) {
  return http(
    "GET",
    `${window.API_URL}/workspace/progressInfo?${qs.stringify(payload)}`
  );
}

function getWorkspacePageInfo(payload) {
  return http(
    "GET",
    `${window.API_URL}/workspace/item/page?${qs.stringify(payload)}`
  );
}

function getWorkspaceItems(payload) {
  return http(
    "GET",
    `${window.API_URL}/workspace/items?${qs.stringify(payload)}`
  );
}

function getWorkspaceItemIdList(payload) {
  return http("POST", `${window.API_URL}/workspace/items/ids`, payload);
}

function getWorkspaceItemDetail(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;

  return http(
    "GET",
    `${window.API_URL}/workspace/item/${taskItemId}?${qs.stringify(payload)}`
  );
}

function executeComplete(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;

  return http(
    "POST",
    `${window.API_URL}/workspace/item/${taskItemId}/execute/complete`,
    payload
  );
}

function executeReject(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;

  return http(
    "POST",
    `${window.API_URL}/workspace/item/${taskItemId}/execute/reject`,
    payload
  );
}

function executeDelete(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;

  return http(
    "POST",
    `${window.API_URL}/workspace/item/${taskItemId}/execute/delete`,
    payload
  );
}

function updateWorkItemData(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;

  return http(
    "PUT",
    `${window.API_URL}/workspace/item/${taskItemId}/result`,
    payload
  );
}

function getOperatorFilter(payload) {
  return http(
    "GET",
    `${window.API_URL}/workspace/operatorFilter?${qs.stringify(payload)}`
  );
}

function getCommentList(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;
  return http("GET", `${window.API_URL}/workspace/${taskItemId}/comments`);
}

function createComment(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;
  return http(
    "POST",
    `${window.API_URL}/workspace/${taskItemId}/comments`,
    payload
  );
}

function createThread(payload) {
  return http(
    "POST",
    `${window.API_URL}/workspace/${payload.taskItemId}/comments/${payload.commentId}`,
    payload.thread
  );
}

function solveComment(payload) {
  const taskItemId = payload.taskItemId;
  const commentId = payload.commentId;
  delete payload.taskItemId;
  delete payload.commentId;

  return http(
    "PUT",
    `${window.API_URL}/workspace/${taskItemId}/comments/${commentId}/solve`,
    payload
  );
}

function unsolveComment(payload) {
  const taskItemId = payload.taskItemId;
  const commentId = payload.commentId;
  delete payload.taskItemId;
  delete payload.commentId;

  return http(
    "PUT",
    `${window.API_URL}/workspace/${taskItemId}/comments/${commentId}/unsolve`,
    payload
  );
}

function postImgSize(payload) {
  const taskItemId = payload.taskItemId;
  delete payload.taskItemId;
  return http(
    "POST",
    `${window.API_URL}/workspace/item/${taskItemId}/image/shape`,
    payload
  );
}

function delayTaskItem(payload) {
  return http("PUT", `${window.API_URL}/workspace/items/delay`, payload);
}

export default {
  getTodoTaskItemId,
  getNextTaskItemId,
  getPrevTaskItemId,
  assignTaskItem,
  getWorkspaceInfo,
  getWorkspaceProgressInfo,
  getWorkspacePageInfo,
  getWorkspaceItems,
  getWorkspaceItemIdList,
  getWorkspaceItemDetail,
  executeComplete,
  executeReject,
  executeDelete,
  updateWorkItemData,
  getOperatorFilter,
  getCommentList,
  createComment,
  createThread,
  solveComment,
  unsolveComment,
  postImgSize,
  delayTaskItem,
};
